module.exports = __webpack_public_path__ + "static/media/frog.26b0a777.jpg";